// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--r54xr","title":"_1410bfd27b--title--uYSop","location":"_1410bfd27b--location--Ws_Pb","search-suggest":"_1410bfd27b--search-suggest--tgcQx"};